<div class="grid infinite justify-content-center grid-nogutter mt-0 relative">
  <app-frame-grid-layout
    *ngIf="items.length"
    [items]="items"
    [trackBy]="trackByItem"
    [frame]="gridFrame"
    [gapPx]="4"
    [appendDisabled]="loading || endOfResults"
    [appendTriggerMarginPx]="1400"
    (appendRequested)="requestNextPage()"
    class="container timeline-container m-0 p-0">
    <ng-template let-item>
      <div class="item item-padding">
        <p-skeleton *ngIf="item.isPlaceholder" width="100%" height="100%"></p-skeleton>
        <div (click)="onTileClick($event, item)" *ngIf="!item.isPlaceholder" class="relative height-100 width-100">
          <div style="position: absolute" class="flex justify-content-center align-items-center mask height-100 width-100">
            <div class="text-center">{{ item.name | translate }}</div>
          </div>
          <img alt="media thumbnail" class="media-thumbnail" [src]="item.thumbnail | mediaObject: {defaultImageType: getDefaultThumbnailByType(slide.key, item)}" width="100%"/>
          <div
            class="vehicle-thumbnails-grid"
            *ngIf="item.vehicleThumbnails?.length"
          >
            <a
              class="vehicle-thumb"
              *ngFor="let vehicleThumb of item.vehicleThumbnails"
              [routerLink]="vehicleThumb.previewUrl"
              [attr.href]="vehicleThumb.previewUrl || null"
              (click)="onVehicleLinkClick($event, vehicleThumb)"
            >
              <img
                alt="vehicle thumbnail"
                class="vehicle-thumb__img"
                [src]="vehicleThumb.thumb | mediaObject: {defaultImageType: 'car', formatType: 'thumb_sm'}"
              />
            </a>
          </div>
        </div>
      </div>
    </ng-template>
  </app-frame-grid-layout>
  <div class="width-100 flex justify-content-center mb-5" *ngIf="loading && !items[0]?.isPlaceholder">
    <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div *ngIf="!items.length && noResultsMsg">
    <p class="muted-text">
      {{noResultsMsg}}
    </p>
  </div>
</div>
